module.exports = __webpack_public_path__ + "static/WEDDING E&M-21-523d4854c9fc41b0ccd833a2bb14136a.jpg";